// extracted by mini-css-extract-plugin
export var fileExt = "_s5-8";
export var fileIcon = "_s5-6";
export var fileLink = "_s5-5";
export var fileName = "_s5-7";
export var image = "_s5-1";
export var imageError = "_s5-3";
export var imageErrorIcon = "_s5-4";
export var imageLink = "_s5-0";
export var imageLoaded = "_s5-2";